import styled from "styled-components";
import { mobile } from "../../../../../ui/_themes/constants";
import {
  getBackgroundColor,
  getColor
} from "../../../../../ui/_themes/helpers";

export const Wrapper = styled.div`
  display: ${props => (props.hidden ? "none" : "flex")};
  width: 100%;
  overflow: hidden;
  user-select: none;
  color: ${getColor("footer")};
  background-color: ${getBackgroundColor("footer")};
  align-items: center;

  > div {
    font-weight: 700;
    font-size: ${mobile.fontSize.xxs};
  }

  /* @see KEYPAD-1720 for details */
  /* height = line-height * font-size + padding-top + padding-bottom */
  /* line-height default value varies for different browsers and font families */
  /* experimentaly found that in our case line-height ~ 1.15 */
  @media (orientation: landscape) {
    padding: 0.1em 2.4em;
    height: 0.73em;
  }

  @media (orientation: portrait) {
    padding: 0.2em 0.8em;
    height: 0.947em;
  }
`;
